<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/UDTda2/tc-custom/9781617455582.jpg?1712927412327" alt="This image is the cover for the book Adventures in Paper Piecing & Design"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Adventures in Paper Piecing & Design
      </h1>
      <p class="bookDescription body article font2">
        <p>Turn your interest in foundation paper-piecing into a full-blown love affair. Learn about every stage of the process—from piecing technique to pattern design—in this comprehensive guide. Start with the basics of sewing on paper, then explore the author’s open-ended design exercises to create your own patterns or follow along with the author’s take to sew her graphic interpretations of the prompts. With an annotated overview of the author’s favorite FPP methods, countless tips, and over thirty paper-pieced quilt blocks plus seven design exercises to put your skills to the test, you’ll have the tools you need to thrive when confronted with any paper-piecing challenge!  - Build your piecing skills with over thirty graphic paper-pieced blocks inspired by everything from house plants to typography to surface pattern design techniques - Learn how to translate your own reference images or sketches into FPP patterns - Sharpen your pattern-design skills with choose-your-own-adventure style exercises "</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sarah Elizabeth Sharp
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      C&T Publishing, Inc
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?38a31f71